export default __webpack_public_path__ + "static/media/motorsports-pitchview-mobile.cb152bf0.png";